<template>
  <div>
    <main>
      <slot></slot>
    </main>
    <ClientOnly>
      <LazyCallWidget />
      <LazyWPWidget />
    </ClientOnly>
    <LazyCookieBanner />
    <LazyReservation />
    <LazySideSocialMedia />
    <LazyRewards />
    <LazyFooter />
  </div>
</template>
